<div>
	<div *ngIf="!endOfVideo" class="shaka-container" [class.player-pip]="pip" [ngClass]="subtitleClass$ | async">
		<div #videoUI id="videoUI">
			<video #videoPlayer data-shaka-player id="video" style="width:100%;" autoplay [poster]="poster"></video>
			<div class="overlay-playback-controls">
				<div class="row-flex w-100" dpadZone="'player-controls'">
					<div class="control-button">
						<button (click)="skipBackward($event)"
							class="shaka-overlay-button shaka-skip-backward p-0 overlay-button" [class.shown]="shown()"
							aria-label="Skip Backward" dpadSelectable>
							<svg width="64" height="64" viewBox="0 0 64 64" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<circle class="button-circle" cx="32" cy="32" r="32" fill="#fff" />
								<path class="button-icon"
									d="M19 20h2v24h-2V20Zm24.499 23.865A.998.998 0 0 0 45 43V21a1 1 0 0 0-1.501-.865l-19 11a1 1 0 0 0 0 1.73l19 11Z"
									fill="#fff" />
							</svg>
						</button>
					</div>
					<div class="control-button">
						<button class="shaka-overlay-button shaka-play-button-v2 p-0 overlay-button dpad-start"
							[class.shown]="shown()" aria-label="Play" (click)="togglePausePlay()" dpadSelectable
							#playButton>
							<svg *ngIf="!isPlaying" width="64" height="64" viewBox="0 0 64 64" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<circle cx="32" cy="32" r="32" fill="white" class="button-circle" />
								<path class="button-icon"
									d="M25 44.0001C24.7348 44.0001 24.4804 43.8947 24.2929 43.7072C24.1054 43.5196 24 43.2653 24 43.0001V21.0001C24 20.8263 24.0453 20.6555 24.1314 20.5046C24.2175 20.3536 24.3414 20.2277 24.491 20.1392C24.6406 20.0508 24.8106 20.0028 24.9844 20.0001C25.1582 19.9974 25.3296 20.04 25.4819 20.1238L45.4819 31.1238C45.6388 31.2101 45.7697 31.3369 45.8608 31.491C45.952 31.6452 46 31.821 46 32C46 32.1791 45.952 32.3549 45.8608 32.509C45.7697 32.6632 45.6388 32.79 45.4819 32.8763L25.4819 43.8763C25.3343 43.9575 25.1685 44 25 44.0001Z"
									fill="white" />
							</svg>
							<svg *ngIf="isPlaying" width="64" height="64" xmlns="http://www.w3.org/2000/svg"
								fill="none">
								<g>
									<circle id="svg_1" fill="#000000" r="32" cy="32" cx="32" class="button-circle" />
									<rect class="button-icon" stroke="null" id="svg_2" height="28.45746" width="7.97873"
										y="16" x="20" fill="#ffffff" />
									<rect class="button-icon" stroke="null" id="svg_3" height="28.45746" width="7.97873"
										y="16" x="35" fill="#ffffff" />
								</g>
							</svg>
						</button>
					</div>
					<div class="control-button">
						<button (click)="skipForward($event)"
							class="shaka-overlay-button shaka-skip-forward p-0 overlay-button" [class.shown]="shown()"
							aria-label="Skip Forward" dpadSelectable>
							<svg width="64" height="64" viewBox="0 0 64 64" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<circle class="button-circle" cx="32" cy="32" r="32" fill="#fff" />
								<path class="button-icon"
									d="M44 20h2v24h-2V20ZM20.293 43.707a1 1 0 0 0 1.208.158l19-11a1 1 0 0 0 0-1.73l-19-11A1 1 0 0 0 20 21v22a1 1 0 0 0 .293.707Z"
									fill="#fff" />
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="overlay-top-controls">
				<div class="row-flex w-100" dpadZone="'top-controls'">
					<div class="control-button">
						<button (click)="returnToPreviousPage()" class="shaka-overlay-button overlay-button"
							[class.shown]="shown()" aria-label="Skip Forward" dpadSelectable>
							<svg viewBox="0 0 64 64" width="64" height="64">
								<circle class="button-circle" r="32" cy="32" cx="32"></circle>
								<g transform="matrix(1, 0, 0, 1, 0.975134, 1.378108)">
									<path class="button-icon"
										d="m31.46173,20.0921c0.24744,0 0.48475,0.09155 0.65974,0.25452c0.17497,0.16296 0.27327,0.38399 0.27327,0.61444l0,19.11727c0,0.15101 -0.04222,0.29942 -0.12256,0.4306c-0.08034,0.13118 -0.19599,0.24059 -0.33554,0.31746c-0.13956,0.07685 -0.29823,0.11852 -0.46034,0.12088c-0.16214,0.0024 -0.32212,-0.03468 -0.46418,-0.10745l-18.66025,-9.55863c-0.14639,-0.07497 -0.26848,-0.18519 -0.35352,-0.31915c-0.08504,-0.13393 -0.12991,-0.28668 -0.12991,-0.44228c0,-0.15562 0.04487,-0.30837 0.12991,-0.4423c0.08504,-0.13395 0.20713,-0.24417 0.35352,-0.31915l18.66025,-9.55863c0.13775,-0.07053 0.29242,-0.10755 0.44963,-0.10757z">
									</path>
								</g>
								<g transform="matrix(1, 0, 0, 1, 0.975134, 1.378108)">
									<rect class="button-icon" stroke="null" x="28.46136" y="28.05648" height="6.22732"
										width="23.14268">
									</rect>
								</g>
							</svg>
						</button>
					</div>
                    <div class="d-flex float-right">
						<div class="control-button position-relative">
							<button class="shaka-overlay-button p-0 overlay-button cc-btn" (click)="addToPlaylist(mediaId)" #watchlistButton
								[class.shown]="shown()" aria-label="Watchlist" dpadSelectable *ngIf="!existsInPlaylist(mediaId) && !addToPlaylistLoading">
								<svg width="39" height="39" viewBox="0 0 20 20" fill="none">
									<line x1="10" y1="5" x2="10" y2="15" stroke="currentColor" stroke-width="2"/>
									<line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
								</svg>
							</button>
							<button class="shaka-overlay-button p-0 overlay-button cc-btn" (click)="deleteFromPlaylist(mediaId)" #watchlistButton
								[class.shown]="shown()" aria-label="Watchlist" dpadSelectable *ngIf="existsInPlaylist(mediaId) && !addToPlaylistLoading">
								<svg width="39" height="39" viewBox="0 0 20 20" fill="none">
									<line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
								</svg>
							</button>
							<button class="shaka-overlay-button p-0 overlay-button background-white cc-btn" #watchlistButton
								[class.shown]="shown()" aria-label="Watchlist" dpadSelectable *ngIf="addToPlaylistLoading">
								<svg xmlns="http://www.w3.org/2000/svg" height="39px" viewBox="0 -960 960 960" width="39px" fill="black"><path d="M480-516q65 0 110.5-45.5T636-672v-120H324v120q0 65 45.5 110.5T480-516ZM192-96v-72h60v-120q0-59 28-109.5t78-82.5q-49-32-77.5-82.5T252-672v-120h-60v-72h576v72h-60v120q0 59-28.5 109.5T602-480q50 32 78 82.5T708-288v120h60v72H192Z"/></svg>
							</button>
                        </div>
                        <div class="control-button position-relative">
                            <button class="shaka-overlay-button p-0 overlay-button cc-btn" (click)="toggleCaptions()"
                                    [class.shown]="shown()" aria-label="Captions" dpadSelectable>
                                <svg width="34" height="39" viewBox="0 0 34 39" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="!captionsOn">
                                    <path class="button-icon" fill-rule="evenodd" clip-rule="evenodd" d="M3 9C1.34315 9 0 10.3431 0 12V27C0 28.6569 1.34315 30 3 30H31C32.6569 30 34 28.6569 34 27V12C34 10.3431 32.6569 9 31 9H3ZM4 11C2.89543 11 2 11.8954 2 13V26C2 27.1046 2.89543 28 4 28H30C31.1046 28 32 27.1046 32 26V13C32 11.8954 31.1046 11 30 11H4Z" fill="white"/>
                                    <rect x="4" y="19" width="3" height="2" fill="white" class="button-icon"/>
                                    <rect x="4" y="19" width="3" height="2" fill="white" class="button-icon"/>
                                    <rect x="10" y="19" width="4" height="2" fill="white" class="button-icon"/>
                                    <rect x="10" y="19" width="4" height="2" fill="white" class="button-icon"/>
                                    <rect x="20" y="24" width="10" height="2" fill="white" class="button-icon"/>
                                    <rect x="20" y="24" width="10" height="2" fill="white" class="button-icon"/>
                                    <rect x="17" y="19" width="13" height="2" fill="white" class="button-icon"/>
                                    <rect x="17" y="19" width="13" height="2" fill="white" class="button-icon"/>
                                    <rect x="4" y="24" width="13" height="2" fill="white" class="button-icon"/>
                                    <rect x="4" y="24" width="13" height="2" fill="white" class="button-icon"/>
                                </svg>
                                <svg width="34" height="39" viewBox="0 0 34 39" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="captionsOn">
                                    <path class="button-icon" fill-rule="evenodd" clip-rule="evenodd" d="M3 9C1.34315 9 0 10.3431 0 12V27C0 28.6569 1.34315 30 3 30H31C32.6569 30 34 28.6569 34 27V12C34 10.3431 32.6569 9 31 9H3ZM7 19H4V21H7V19ZM10 19H14V21H10V19ZM30 24H20V26H30V24ZM17 19H30V21H17V19ZM17 24H4V26H17V24Z" fill="white"/>
                                </svg>
                            </button>
                        </div>
                        <div class="control-button position-relative">
                            <button class="shaka-overlay-button p-0 overlay-button cc-btn" (click)="modal()"
                                    [class.shown]="shown()" aria-label="Report Media" dpadSelectable>
                                <svg width="64" height="64" viewBox="0 0 64 64">
                                    <g transform="matrix(0.191617, 0, 0, 0.186837, 16.11842, 26.29051)">
                                        <rect x="9.819" y="-58.51" width="20" height="164" class="button-icon" />
                                        <rect x="156.819" y="-46.51" width="20" height="75" class="button-icon" />
                                        <path
                                                d="M 9.819 -58.51 C 36.808 -68.206 66.33 -68.206 93.319 -58.51 C 120.308 -48.813 149.83 -48.813 176.819 -58.51 L 176.819 -38.51 C 149.83 -28.813 120.308 -28.813 93.319 -38.51 C 66.33 -48.206 36.808 -48.206 9.819 -38.51 L 9.819 -58.51 Z"
                                                class="button-icon" />
                                        <path
                                                d="M 9.819 22.49 C 36.808 12.793 66.33 12.793 93.319 22.49 C 120.308 32.187 149.83 32.187 176.819 22.49 L 176.819 42.49 C 149.83 52.187 120.308 52.187 93.319 42.49 C 66.33 32.793 36.808 32.793 9.819 42.49 L 9.819 22.49 Z"
                                                class="button-icon" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>

				</div>
			</div>
			<div class="shaka-overlay-details" [class.shown]="shown()">
				<h3 class="shaka-title">{{title}}</h3>
			</div>
			<!--<div class="video-countdown" *ngIf="autoplayNextVideo == true && autoplay && timeLeft < 20">
                <div class="video-countdown-text">
                    Next video in<br />
                    <span class="video-countdown-time">{{timeLeft | number: '1.0-0'}}</span>
                </div>
            </div>-->
			<div id="seek-preview"></div>
		</div>
	</div>

	<div *ngIf="endOfVideo" class="ar-169" dpadZone="'end-of-video'">
		<div class="centered">
			<div *ngIf="!cancelled && endOfVideoTime > -1">
				<h4 class="text-dull d-inline-block">Next video in&nbsp;&nbsp;
				</h4>
				<h3 class="d-inline-block">{{endOfVideoTime}}</h3>
			</div>
			<div>
				<img class="my-2" src="{{endOfVideoImage}}" width="300px" alt="Next Video" />
			</div>
			<div>
				<div>
					<button *ngIf="!cancelled && endOfVideoTime > -1" dpadSelectable
						class="btn btn btn-outline-light mr-2 w-48 btn-stv"
						(click)="cancelNextVideoTimer()">CANCEL</button>
					<button class="btn btn btn-outline-light w-48 btn-stv dpad-start" #playNext
						[class.w-100]="cancelled" dpadSelectable (click)="playNextVideo()"
						(keyup.enter)="playNextVideo()">PLAY</button>
				</div>
				<div class="mt-2">
					<button class="btn btn-outline-light w-100 btn-stv" (click)="watchAgain()"
						(keyup.enter)="watchAgain()" dpadSelectable>WATCH AGAIN</button>
				</div>
			</div>
		</div>
	</div>

</div>

<report-media-modal *ngIf="showReportMediaModal" (closeModal)="closeReportMediaModal()" [mediaId]="mediaId"
			[elementFocusCallback]="focusElement"></report-media-modal>
